<template>
  <div class="container">
    <h2 class="header"><i class="fas fa-user-edit"></i> Editar usuario</h2>
    <!-- -->
    <div class="form-group" v-if="user">
      <label for="name">Nombre:</label>
      <input type="text" v-model="user.name" class="form-control" id="name" />
      <span class="text-danger" v-if="errors.name">
        {{ errors.name[0] }}
      </span>
    </div>
    <div class="form-group" v-if="user">
      <label for="email">Correo Electronico:</label>
      <input
        type="email"
        v-model="user.email"
        class="form-control"
        id="email"
      />
      <span class="text-danger" v-if="errors.email">
        {{ errors.email[0] }}
      </span>
    </div>
    <div class="form-group" v-if="user">
      <label for="password">Contraseña:</label>
      <input
        type="password"
        v-model="user.password"
        class="form-control"
        id="password"
      />
      <span class="text-danger" v-if="errors.password">
        {{ errors.password[0] }}
      </span>
    </div>
    <!-- -->
    <div class="btn-group" role="group" aria-label="Basic example">
      <router-link class="btn btn-success btn-lg" :to="{ name: 'Dashboard' }">
        <i class="fas fa-hand-point-left"></i> Regresar
      </router-link>
      <button
        type="button"
        class="btn btn-danger btn-lg"
        @click.prevent="guardar()"
      >
        <i class="fas fa-save"></i> Guardar Cambios
      </button>
    </div>
    <pre>{{ user }}</pre>
  </div>
</template>

<script>
import User from "../../apis/User";

export default {
  data() {
    return {
      user: null,
      errors: []
    };
  },
  created() {
    User.ver(this.$route.params.id).then(r => {
      this.user = r.data;
    });
  },
  methods: {
    guardar: function() {
      //console.log("guardar usuario");
      //console.log(this.user);
      User.guardar(this.user)
        .then(() => {
          this.$router.push({ name: "Dashboard" });
        })
        .catch(error => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
        });
    }
  }
};
</script>
